;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "VerificationSuccessful",
  props: {
    success_message: {
      type: String,
      default: "Verification Successful!"
    },
    info_message: {
      type: String,
      default: "You've verified card ownership"
    },
    processing_message: {
      type: String,
      default: "Processing payment..."
    },
    completing_transaction_message: {
      type: String,
      default: "Completing transaction"
    },
    amount_message: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    NextStep: function NextStep() {
      this.$emit('proceed');
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col gap-5 mx-auto items-center text-center"},[_c('div',{staticClass:"w-full p-4 bg-[#dfffee] rounded-lg inline-flex items-center gap-2.5"},[_c('div',{staticClass:"relative w-5 h-5 flex items-center justify-center"},[_c('div',{staticClass:"absolute inset-0 bg-[#009247] rounded-full border-2 border-[#009247]"}),_vm._v(" "),_c('svg',{staticClass:"relative z-10 w-3 h-3 text-white",attrs:{"fill":"none","stroke":"currentColor","stroke-width":"2","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M5 13l4 4L19 7"}})])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"text-[#4c4f59] text-sm font-semibold font-['Inter'] leading-[21px]"},[_vm._v(_vm._s(_vm.success_message)+"\n      ")]),_vm._v(" "),_c('span',{staticClass:"text-[#4c4f59] text-sm font-normal font-['Inter'] leading-[21px]"},[_vm._v(_vm._s(_vm.info_message))])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-col gap-5 max-w-lg mx-auto items-center text-center lg:mt-20 mt-10"},[_c('p',{staticClass:"lg:text-[28px] text-2xl leading-normal text-[#4C4F59] font-semibold"},[_vm._v("\n      "+_vm._s(_vm.processing_message)+"\n    ")]),_vm._v(" "),_c('p',{staticClass:"text-base text-[#5E5E5E]"},[_vm._v(_vm._s(_vm.completing_transaction_message))]),_vm._v(" "),_c('div',{staticClass:"bg-[#1E1BDD0D] rounded-lg p-2.5 flex items-center gap-2 text-[#5D5D5D] font-bold"},[_c('p',[_vm._v(_vm._s(_vm.amount_message)+" ")])]),_vm._v(" "),_vm._m(0)])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center justify-center gap-2 mt-8"},[_c('span',{staticClass:"w-3 h-3 bg-gray-400 rounded-full animate-bounce [animation-delay:-0.3s]"}),_vm._v(" "),_c('span',{staticClass:"w-3 h-3 bg-gray-400 rounded-full animate-bounce [animation-delay:-0.15s]"}),_vm._v(" "),_c('span',{staticClass:"w-3 h-3 bg-gray-400 rounded-full animate-bounce"})])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f0ec01bc", __vue__options__)
  } else {
    hotAPI.reload("data-v-f0ec01bc", __vue__options__)
  }
})()}